module.exports = __webpack_public_path__ + "static/media/icon_video.22292a0a.svg";